module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5.a1c8c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5.png
// module id = F6iA
// module chunks = 34